import "./bootstrap";

// import './laravel-echo.js';

// 🌙 Dark Mode Store para Alpine.js (usando la instancia de Livewire)
document.addEventListener("livewire:init", () => {
    // Usar la instancia de Alpine que ya tiene Livewire
    if (window.Alpine) {
        window.Alpine.store("theme", {
            // Inicializar tema basado en localStorage o, si no hay preferencia guardada,
            // usar la preferencia del sistema (resolviendo a light o dark)
            theme:
                localStorage.getItem("theme") ||
                (window.matchMedia("(prefers-color-scheme: dark)").matches
                    ? "dark"
                    : "light"),

            get isDark() {
                return this.theme === "dark";
            },

            // Toggle solo entre light y dark
            toggle() {
                this.theme = this.theme === "dark" ? "light" : "dark";
                this.updateDOM();
            },

            // Actualizar el DOM con data-theme
            updateDOM() {
                localStorage.setItem("theme", this.theme);
                document.documentElement.setAttribute("data-theme", this.theme);
            },

            // Inicializar el dark mode
            init() {
                this.updateDOM();

                // Escuchar cambios en la preferencia del sistema solo si no hay preferencia guardada
                window
                    .matchMedia("(prefers-color-scheme: dark)")
                    .addEventListener("change", (e) => {
                        if (!localStorage.getItem("theme")) {
                            this.theme = e.matches ? "dark" : "light";
                            this.updateDOM();
                        }
                    });
            },
        });

        // Inicializar el store
        window.Alpine.store("theme").init();
    }
});

// 🎭 Intersection Observer para animaciones
const observer = new IntersectionObserver(
    (entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add("visible");
                observer.unobserve(entry.target); // 🔥 anima una sola vez
            }
        });
    },
    { threshold: 0.2 },
);

document
    .querySelectorAll(".fade-section")
    .forEach((el) => observer.observe(el));
